<template>
  <div>
    <div class="overflow-hidden flex justify-center">
      <div>
        <div class="head m-b-6">
          <h2 style="margin-bottom: 13px">!سلام</h2>
          <p>لطفاجزئیات زیر را که برای حساب کاربری شماست</p>
          <p>با دقت کامل فرمائید</p>
        </div>
        <div class="items-center m-b-2">
          <div class="mx-auto max-w-screen-xl m-b-126">
            <input
              type="password"
              class="pass-input"
              v-model="password"
              v-if="!showPass"
              placeholder="گذرواژه"
            />
            <input
              class="pass-input"
              v-model="password"
              v-if="showPass"
              placeholder="گذرواژه"
            />
            <img
              src="@/assets/icons8-eye-26.png"
              @click="showPassHandler"
              class="pass-eye"
            />

            <input
              type="password"
              class="pass-input"
              v-model="rpassword"
              v-if="!showrPass"
              placeholder="تکرار گذرواژه"
            />
            <input
              class="pass-input"
              v-model="rpassword"
              v-if="showrPass"
              placeholder="تکرار گذرواژه"
            />
            <img
              src="@/assets/icons8-eye-26.png"
              @click="showrPassHandler"
              class="pass-eye"
            />
            <input
              type="checkbox"
              id="scales"
              v-model="rulse"
              style="float: right"
            />
            <p>با قوانین و شرایط استفاده موافقت دارم.</p>
          </div>
        </div>
        <button class="m-btn" @click="savePassrHandler" :disabled="!rulse">
          ارسال کد
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPass: false,
      showrPass: false,
      password: null,
      rpassword: null,
      rulse: false,
    };
  },
  methods: {
    showPassHandler() {
      this.showPass = !this.showPass;
    },
    showrPassHandler() {
      this.showrPass = !this.showrPass;
    },
    hash() {
      var hash = 0,
        i,
        chr;
      if (this.length === 0) return hash;
      for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
    savePassrHandler() {
      if (this.password == this.rpassword) {
        var pass = this.hash(this.password);

        window.localStorage.setItem("pass", pass);
      }
    },
  },
};
</script>
